import { moduleProviderFactory } from 'core/providers';
import { isSeller } from 'core/utils';
import { ShipmentCost } from 'modules/shipment-cost/pages';
import _ from 'lodash';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.shipment-cost',
				pattern: '/shipment-cost',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.shipment-cost',
						pattern: '',
						authorization: rootStore =>
							rootStore.authStore.hasPermission('shipmentCostSection.full') &&
							(!isSeller(rootStore) ||
								_.get(rootStore.organization, 'sellerOrganizationInfo.showSurplusCharge', false)),
						component: ShipmentCost,
					},
				],
			},
		],
	});
})();
